import React from 'react';

export default function Banner({ tone = 'info', children }) {
  const styles = {
    info: 'bg-[#e6f1ff] text-[#005fb8] border-[#b8d9ff]',
    warn: 'bg-[#e6f1ff] text-[#005fb8] border-[#b8d9ff] border-l-4 border-l-[#0089ff] font-medium',
    error:
      'bg-[rgba(254,226,226,0.6)] text-[#f23e41] border-[#fecaca] border-l-4 border-l-[#f23e41]',
  }[tone];
  const icon = { warn: 'error', error: 'cancel' }[tone];
  return (
    <div
      data-tone={tone}
      // ANNOUNCED, not just drawn. Most of these appear in RESPONSE to something the operator did -
      // a refresh that was rate limited, a save that reformatted the text, a statement that could
      // not be opened - and a screen reader was given no indication that anything had happened at
      // all. `alert` is assertive and is reserved for failures; everything else is polite.
      role={tone === 'error' ? 'alert' : 'status'}
      className={`border rounded-lg px-4 py-3 text-sm mb-4 flex items-start gap-2 ${styles}`}
    >
      {icon && (
        <span
          aria-hidden="true"
          className="material-symbols-outlined text-[18px] leading-5 shrink-0"
        >
          {icon}
        </span>
      )}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
